<template>
  <navigation-tabs
    class="merge-request-navigation-bar"
    :is-reactive="true"
    :links="filteredMenuItems"
  />
</template>

<script>
import mergeRequestMessages from '@shared/modules/merge-request/mergeRequestMessages';
import NavigationTabs from '@shared/shared-components/shared/navigation-tabs';

export default {
  name: 'MergeRequestNavigationBar',
  components: { NavigationTabs },
  props: {
    showCi: {
      type: Boolean,
      default: false
    },
    showSecurity: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    alias() {
      return this.$route.params?.alias;
    },
    projectAlias() {
      return this.$route.params?.projectAlias;
    },
    mergeRequestId() {
      return this.$route.params?.id;
    },
    menuItems() {
      return [
        {
          title: this.$tc('discussion', 2),
          to: {
            name: 'merge-request-item',
            params: {
              alias: this.alias,
              projectAlias: this.projectAlias,
              id: this.mergeRequestId
            }
          },
          icon: 'gf-icon gf-icon-comments'
        },
        {
          title: this.$tc('message.commit', 1),
          to: {
            name: 'merge-request-item-commit',
            params: {
              alias: this.alias,
              projectAlias: this.projectAlias,
              id: this.mergeRequestId
            }
          },
          icon: 'gf-icon gf-icon-dot'
        },
        {
          title: this.$tc('pipeline', 2),
          to: {
            name: 'merge-request-pipeline',
            params: {
              alias: this.alias,
              projectAlias: this.projectAlias,
              id: this.mergeRequestId
            }
          },
          icon: 'gf-icon gf-icon-conveyor'
        },
        {
          title: this.$t('message.security'),
          to: {
            name: 'merge-request-security',
            params: {
              alias: this.alias,
              projectAlias: this.projectAlias,
              id: this.mergeRequestId
            }
          },
          icon: 'gf-icon gf-icon-shield'
        },
        {
          title: this.$t('message.changes'),
          to: {
            name: 'merge-request-item-diff',
            params: {
              alias: this.alias,
              projectAlias: this.projectAlias,
              id: this.mergeRequestId
            }
          },
          icon: 'gf-icon gf-icon-file-code'
        }
      ];
    },
    filteredMenuItems() {
      return this.menuItems.filter((item) => {
        if (
          (!this.showCi && item.to.name === 'merge-request-pipeline') ||
          (!this.showSecurity && item.to.name === 'merge-request-security')
        ) {
          return false;
        }
        return true;
      });
    }
  },
  i18n: { messages: mergeRequestMessages }
};
</script>

<style lang="scss">
$this: '.merge-request-navigation-bar';

#{$this} {
  .nav {
    overflow-x: hidden;
    overflow-y: hidden;

    @include theme.max-md {
      overflow-x: scroll;
    }
  }
}
</style>
